// Soulcake's logo, leading back to the Main App (main.soulcake.eu), whose top bar opens the Scheduler and Inventory
// (Viktor, 15 Oct 2026: "soulcake icon on top that takes us back to main.soulcake.eu", then "more like floating in the
// middle of inventory and paul"). BackHeader shows it between the title and the buttons on the right; the round back
// button beside the title still goes to this app's own start.
export const MAIN_APP = "https://main.soulcake.eu";

export default function HomeLogo({ className = "" }: { className?: string }) {
  return (
    <a
      href={MAIN_APP}
      title="Back to the Main App (main.soulcake.eu)"
      className={`shrink-0 rounded-[10px] transition-transform active:scale-95 ${className}`}
    >
      <img src="/logo.png" alt="Soulcake: back to the Main App" className="h-10 w-auto" />
    </a>
  );
}
